import { render, staticRenderFns } from "./heat_factor.vue?vue&type=template&id=5c830523&scoped=true"
import script from "./heat_factor.vue?vue&type=script&lang=js"
export * from "./heat_factor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c830523",
  null
  
)

export default component.exports